/**
 * Centralized company name mapping utility
 * Maps internal company names to display names for consistency across the application
 */

export const COMPANY_NAME_MAP = {
  RealtyOne: 'Realty One',
  EasyStorageSoftware: 'Easy Storage Software',
  FreedomMerchant: 'Freedom Merchant',
  Vb360: 'VB360',
};

/**
 * Normalizes a company name using the centralized mapping
 * @param {string} companyName - The company name to normalize
 * @returns {string} - The normalized company name
 */
export const normalizeCompanyName = (companyName) => {
  return COMPANY_NAME_MAP[companyName] || companyName;
};

/**
 * Normalizes company names in an object
 * @param {Object} obj - Object that may contain company names
 * @param {string} [companyKey='company'] - Key that contains the company name
 * @returns {Object} - Object with normalized company name
 */
export const normalizeCompanyInObject = (obj, companyKey = 'company') => {
  if (!obj || typeof obj !== 'object') return obj;
  
  return {
    ...obj,
    [companyKey]: normalizeCompanyName(obj[companyKey])
  };
};
